export const malwarePosts = [
  {
    id: 'm1',
    user_id: 'user31',
    type: 'feed' as const,
    category: 'malware',
    title: 'npm 악성 패키지 "ethers-provider2" - 크립토 지갑 시드 탈취',
    content: '인기 라이브러리 ethers.js를 사칭한 악성 npm 패키지가 발견됐습니다. 설치 시 postinstall 스크립트로 환경변수와 지갑 시드 구문을 원격 서버로 전송합니다. 이미 3,200회 이상 다운로드됐으며 npm에서 제거됐지만 사용 중인 프로젝트 즉시 점검 필요합니다.',
    tags: ['npm', 'supply-chain', 'malware', 'crypto', 'web3'],
    status: 'open',
    is_pinned: true,
    likes_count: 2134,
    replies_count: 95,
    views_count: 18900,
    created_at: new Date(Date.now() - 1 * 3600000).toISOString(),
    profiles: {
      id: 'user31',
      username: 'malware_analyst',
      display_name: 'Malware Analyst',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 'm2',
    user_id: 'user32',
    type: 'feed' as const,
    category: 'malware',
    title: 'LockBit 4.0 랜섬웨어 분석 - 새로운 암호화 알고리즘 적용',
    content: 'LockBit 그룹이 4.0 버전을 출시했습니다. ChaCha20 대신 AES-256-GCM과 RSA-4096 조합을 사용하며, EDR 탐지 우회를 위한 새로운 난독화 기법이 적용됐습니다. 윈도우 이벤트 로그 삭제와 볼륨 섀도우 복사본 제거 기능도 강화됐습니다. 상세 분석 리포트를 공유합니다.',
    tags: ['lockbit', 'ransomware', 'encryption', 'edr-evasion', 'malware-analysis'],
    status: 'open',
    is_pinned: false,
    likes_count: 1876,
    replies_count: 72,
    views_count: 15600,
    created_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    profiles: {
      id: 'user32',
      username: 'ransomware_hunter',
      display_name: 'Ransomware Hunter',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'm3',
    user_id: 'user33',
    type: 'feed' as const,
    category: 'malware',
    title: 'Emotet 봇넷 재등장 - 2025년 새로운 유포 캠페인 분석',
    content: '2021년 테이크다운 이후 잠잠했던 Emotet 봇넷이 새로운 인프라로 재등장했습니다. OneNote 첨부파일을 통한 초기 감염 후 Cobalt Strike 비콘을 드롭하는 방식으로 진화했으며, 한국을 포함한 아시아 지역을 집중 타겟하고 있습니다. IOC와 탐지 룰을 공유합니다.',
    tags: ['emotet', 'botnet', 'malware-campaign', 'cobalt-strike', 'apt'],
    status: 'open',
    is_pinned: false,
    likes_count: 2345,
    replies_count: 88,
    views_count: 19200,
    created_at: new Date(Date.now() - 5 * 3600000).toISOString(),
    profiles: {
      id: 'user33',
      username: 'botnet_tracker',
      display_name: 'Botnet Tracker',
      points: 15230,
      reputation: 4680
    }
  },
  {
    id: 'm4',
    user_id: 'user34',
    type: 'feed' as const,
    category: 'malware',
    title: 'Android 뱅킹 트로이목마 "FluBot" 변종 - SMS 탈취 기능 강화',
    content: 'FluBot 안드로이드 뱅킹 트로이목마의 새로운 변종이 발견됐습니다. 접근성 서비스를 악용하여 2FA SMS를 실시간으로 가로채고, 화면 오버레이로 은행 앱 로그인 정보를 탈취합니다. Google Play Protect를 우회하는 새로운 패킹 기법도 적용됐습니다.',
    tags: ['android', 'banking-trojan', 'flubot', 'mobile-malware', 'sms'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 61,
    views_count: 12300,
    created_at: new Date(Date.now() - 7 * 3600000).toISOString(),
    profiles: {
      id: 'user34',
      username: 'mobile_malware',
      display_name: 'Mobile Malware Expert',
      points: 12890,
      reputation: 3890
    }
  },
  {
    id: 'm5',
    user_id: 'user35',
    type: 'feed' as const,
    category: 'malware',
    title: 'Qakbot 후속 멀웨어 "DarkGate" - RaaS 모델로 전환',
    content: 'Qakbot 테이크다운 이후 그 자리를 차지한 DarkGate 멀웨어를 분석했습니다. RaaS(Ransomware-as-a-Service) 모델로 운영되며, AutoIt 스크립트 기반의 독특한 구조를 가지고 있습니다. C2 통신에 암호화된 WebSocket을 사용하여 탐지가 어렵습니다.',
    tags: ['darkgate', 'raas', 'malware', 'c2', 'autoit'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 69,
    views_count: 14100,
    created_at: new Date(Date.now() - 9 * 3600000).toISOString(),
    profiles: {
      id: 'user35',
      username: 'threat_intel',
      display_name: 'Threat Intelligence',
      points: 13670,
      reputation: 4210
    }
  },
  {
    id: 'm6',
    user_id: 'user36',
    type: 'feed' as const,
    category: 'malware',
    title: 'macOS 타겟 스틸러 "Atomic Stealer" - 키체인 덤프 기능 추가',
    content: 'macOS를 타겟으로 하는 Atomic Stealer(AMOS)의 최신 버전이 발견됐습니다. 키체인 비밀번호 덤프, 브라우저 쿠키 탈취, 크립토 지갑 시드 추출 기능이 모두 포함되어 있으며, Gatekeeper를 우회하는 새로운 서명 기법을 사용합니다.',
    tags: ['macos', 'stealer', 'atomic', 'keychain', 'infostealer'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 54,
    views_count: 10800,
    created_at: new Date(Date.now() - 11 * 3600000).toISOString(),
    profiles: {
      id: 'user36',
      username: 'mac_malware',
      display_name: 'Mac Malware Researcher',
      points: 11450,
      reputation: 3450
    }
  },
  {
    id: 'm7',
    user_id: 'user37',
    type: 'feed' as const,
    category: 'malware',
    title: 'IcedID 멀웨어 새로운 유포 방식 - ISO 파일 내 LNK 악용',
    content: 'IcedID 뱅킹 트로이목마가 새로운 유포 방식을 사용하고 있습니다. ISO 이미지 파일 내부에 LNK 파일을 숨기고, 이를 통해 PowerShell 스크립트를 실행하여 최종 페이로드를 다운로드합니다. Mark-of-the-Web 보호를 우회하는 효과적인 방법입니다.',
    tags: ['icedid', 'banking-trojan', 'iso', 'motw-bypass', 'delivery'],
    status: 'open',
    is_pinned: false,
    likes_count: 1234,
    replies_count: 48,
    views_count: 9200,
    created_at: new Date(Date.now() - 13 * 3600000).toISOString(),
    profiles: {
      id: 'user37',
      username: 'malware_reverse',
      display_name: 'Malware Reverser',
      points: 12340,
      reputation: 3780
    }
  },
  {
    id: 'm8',
    user_id: 'user38',
    type: 'feed' as const,
    category: 'malware',
    title: 'Python 기반 RAT "PyDoor" - 크로스 플랫폼 백도어 분석',
    content: 'Python으로 작성된 크로스 플랫폼 RAT인 PyDoor를 분석했습니다. Windows, Linux, macOS 모두에서 동작하며, PyInstaller로 패킹되어 배포됩니다. 키로깅, 스크린샷, 파일 탈취 등 기본 RAT 기능과 함께 암호화폐 채굴 모듈도 포함되어 있습니다.',
    tags: ['python', 'rat', 'cross-platform', 'backdoor', 'pyinstaller'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 59,
    views_count: 11400,
    created_at: new Date(Date.now() - 15 * 3600000).toISOString(),
    profiles: {
      id: 'user38',
      username: 'rat_hunter',
      display_name: 'RAT Hunter',
      points: 10890,
      reputation: 3290
    }
  },
  {
    id: 'm9',
    user_id: 'user39',
    type: 'feed' as const,
    category: 'malware',
    title: 'Cobalt Strike 비콘 탐지 우회 - Malleable C2 프로파일 분석',
    content: '실제 APT 공격에서 사용된 Cobalt Strike Malleable C2 프로파일을 분석했습니다. 정상 트래픽으로 위장하기 위해 jQuery CDN을 모방하고, 암호화된 페이로드를 PNG 이미지 스테가노그래피로 숨기는 고도화된 기법을 사용합니다. 탐지 방법론을 제시합니다.',
    tags: ['cobalt-strike', 'c2', 'malleable', 'evasion', 'apt'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 81,
    views_count: 17300,
    created_at: new Date(Date.now() - 17 * 3600000).toISOString(),
    profiles: {
      id: 'user39',
      username: 'c2_analyst',
      display_name: 'C2 Analyst',
      points: 14560,
      reputation: 4450
    }
  },
  {
    id: 'm10',
    user_id: 'user40',
    type: 'feed' as const,
    category: 'malware',
    title: 'Linux 서버 타겟 크립토마이너 "Kinsing" - 컨테이너 탈출 기능',
    content: 'Kinsing 크립토마이너의 새로운 변종이 Docker 컨테이너 탈출 기능을 포함하게 됐습니다. 잘못 설정된 Docker API를 통해 초기 침투 후, 호스트로 탈출하여 XMRig 마이너를 설치합니다. Redis, Kubernetes API 등 다양한 진입점을 악용합니다.',
    tags: ['linux', 'cryptominer', 'kinsing', 'container-escape', 'docker'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 63,
    views_count: 12900,
    created_at: new Date(Date.now() - 19 * 3600000).toISOString(),
    profiles: {
      id: 'user40',
      username: 'linux_malware',
      display_name: 'Linux Malware Expert',
      points: 11230,
      reputation: 3410
    }
  },
  {
    id: 'm11',
    user_id: 'user41',
    type: 'feed' as const,
    category: 'malware',
    title: 'Chrome 확장 프로그램 악성코드 - 쿠키 탈취 및 세션 하이재킹',
    content: '정상 확장 프로그램으로 위장한 악성 Chrome 확장이 발견됐습니다. 설치 후 업데이트를 통해 악성 코드를 주입하며, 모든 웹사이트의 쿠키와 로컬스토리지를 탈취합니다. 특히 암호화폐 거래소와 은행 사이트의 세션을 타겟으로 합니다.',
    tags: ['chrome', 'extension', 'cookie-theft', 'session-hijacking', 'browser'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 71,
    views_count: 14700,
    created_at: new Date(Date.now() - 21 * 3600000).toISOString(),
    profiles: {
      id: 'user41',
      username: 'browser_sec',
      display_name: 'Browser Security',
      points: 10670,
      reputation: 3230
    }
  },
  {
    id: 'm12',
    user_id: 'user42',
    type: 'feed' as const,
    category: 'malware',
    title: 'APT29 (Cozy Bear) 새로운 백도어 "MagicWeb" 분석',
    content: 'APT29 그룹이 사용하는 새로운 백도어 MagicWeb을 분석했습니다. Azure AD Federation 서버를 타겟으로 하며, SAML 토큰을 조작하여 모든 클라우드 리소스에 접근할 수 있습니다. 매우 은밀하게 동작하며 탐지가 극히 어렵습니다.',
    tags: ['apt29', 'magicweb', 'azure-ad', 'saml', 'nation-state'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 93,
    views_count: 20100,
    created_at: new Date(Date.now() - 23 * 3600000).toISOString(),
    profiles: {
      id: 'user42',
      username: 'apt_tracker',
      display_name: 'APT Tracker',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 'm13',
    user_id: 'user43',
    type: 'feed' as const,
    category: 'malware',
    title: 'Discord CDN 악용 멀웨어 유포 - 대규모 캠페인 분석',
    content: 'Discord CDN을 악용하여 멀웨어를 유포하는 대규모 캠페인이 진행 중입니다. 정상 Discord 도메인을 사용하기 때문에 대부분의 보안 솔루션을 우회하며, 게임 핵 프로그램으로 위장하여 청소년층을 타겟합니다. RedLine Stealer와 XMRig를 드롭합니다.',
    tags: ['discord', 'cdn-abuse', 'malware-delivery', 'redline', 'social-engineering'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 64,
    views_count: 12100,
    created_at: new Date(Date.now() - 25 * 3600000).toISOString(),
    profiles: {
      id: 'user43',
      username: 'social_eng',
      display_name: 'Social Engineering Expert',
      points: 9890,
      reputation: 2980
    }
  },
  {
    id: 'm14',
    user_id: 'user44',
    type: 'feed' as const,
    category: 'malware',
    title: 'Rust 기반 랜섬웨어 "BlackCat" (ALPHV) 진화 분석',
    content: 'Rust로 작성된 BlackCat 랜섬웨어의 최신 버전을 분석했습니다. 크로스 플랫폼 지원이 강화됐으며, ESXi 서버를 직접 타겟하는 모듈이 추가됐습니다. 이중 갈취(double extortion) 전술과 함께 DDoS 공격 위협도 추가되어 3중 갈취 모델로 진화했습니다.',
    tags: ['blackcat', 'alphv', 'ransomware', 'rust', 'esxi'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 86,
    views_count: 18400,
    created_at: new Date(Date.now() - 27 * 3600000).toISOString(),
    profiles: {
      id: 'user44',
      username: 'ransomware_pro',
      display_name: 'Ransomware Professional',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 'm15',
    user_id: 'user45',
    type: 'feed' as const,
    category: 'malware',
    title: 'iOS 타겟 스파이웨어 "LightSpy" - 제로클릭 익스플로잇 체인',
    content: 'iOS를 타겟으로 하는 LightSpy 스파이웨어가 제로클릭 익스플로잇 체인을 사용하여 유포되고 있습니다. iMessage 취약점을 통해 사용자 상호작용 없이 감염되며, 위치 추적, 통화 녹음, 메시지 탈취 등 전방위 감시 기능을 수행합니다.',
    tags: ['ios', 'spyware', 'lightspy', 'zero-click', 'imessage'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 98,
    views_count: 21800,
    created_at: new Date(Date.now() - 29 * 3600000).toISOString(),
    profiles: {
      id: 'user45',
      username: 'ios_security',
      display_name: 'iOS Security Researcher',
      points: 17230,
      reputation: 5340
    }
  },
  {
    id: 'm16',
    user_id: 'user46',
    type: 'feed' as const,
    category: 'malware',
    title: 'Golang 기반 봇넷 "Zerobot" - IoT 기기 대규모 감염',
    content: 'Golang으로 작성된 Zerobot이 IoT 기기를 대규모로 감염시키고 있습니다. 라우터, IP 카메라, NAS 등을 타겟으로 하며, 11개 이상의 익스플로잇을 내장하고 있습니다. DDoS 공격과 크립토마이닝을 동시에 수행하며, 자가 전파 기능도 포함되어 있습니다.',
    tags: ['golang', 'botnet', 'iot', 'zerobot', 'ddos'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 57,
    views_count: 10900,
    created_at: new Date(Date.now() - 31 * 3600000).toISOString(),
    profiles: {
      id: 'user46',
      username: 'iot_hunter',
      display_name: 'IoT Hunter',
      points: 11450,
      reputation: 3450
    }
  },
  {
    id: 'm17',
    user_id: 'user47',
    type: 'feed' as const,
    category: 'malware',
    title: 'Lazarus Group 새로운 공급망 공격 - 3CX 사태 재현',
    content: 'Lazarus Group이 또 다른 소프트웨어 공급망 공격을 시도했습니다. 이번에는 보안 소프트웨어 업데이트 서버를 장악하여 정상 업데이트에 백도어를 삽입했습니다. 3CX 사태와 유사한 패턴이며, 암호화폐 거래소와 금융 기관을 주요 타겟으로 합니다.',
    tags: ['lazarus', 'supply-chain', 'apt', 'north-korea', 'backdoor'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 104,
    views_count: 23400,
    created_at: new Date(Date.now() - 33 * 3600000).toISOString(),
    profiles: {
      id: 'user47',
      username: 'apt_analyst',
      display_name: 'APT Analyst',
      points: 18450,
      reputation: 5670
    }
  },
  {
    id: 'm18',
    user_id: 'user48',
    type: 'feed' as const,
    category: 'malware',
    title: 'Windows Defender 우회 기법 - AMSI 패치 새로운 방법론',
    content: 'Windows Defender와 AMSI(Antimalware Scan Interface)를 우회하는 새로운 기법을 분석했습니다. 메모리 패치 대신 ETW(Event Tracing for Windows)를 무력화하는 방식으로, 대부분의 EDR 솔루션이 탐지하지 못합니다. 실제 레드팀 작전에서 사용된 기법입니다.',
    tags: ['windows', 'defender', 'amsi-bypass', 'edr-evasion', 'redteam'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 79,
    views_count: 16800,
    created_at: new Date(Date.now() - 35 * 3600000).toISOString(),
    profiles: {
      id: 'user48',
      username: 'evasion_master',
      display_name: 'Evasion Master',
      points: 14890,
      reputation: 4560
    }
  },
  {
    id: 'm19',
    user_id: 'user49',
    type: 'feed' as const,
    category: 'malware',
    title: 'Jupyter Infostealer 최신 버전 - MFA 토큰 탈취 기능 추가',
    content: 'Jupyter Infostealer의 최신 버전이 MFA 토큰 탈취 기능을 포함하게 됐습니다. Google Authenticator, Authy 등의 2FA 시드를 추출하며, 브라우저에 저장된 세션 쿠키와 결합하여 계정을 완전히 장악할 수 있습니다. C2 서버와의 통신에 Telegram API를 사용합니다.',
    tags: ['jupyter', 'infostealer', 'mfa', '2fa', 'credential-theft'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 68,
    views_count: 13600,
    created_at: new Date(Date.now() - 37 * 3600000).toISOString(),
    profiles: {
      id: 'user49',
      username: 'stealer_analyst',
      display_name: 'Stealer Analyst',
      points: 12670,
      reputation: 3890
    }
  },
  {
    id: 'm20',
    user_id: 'user50',
    type: 'feed' as const,
    category: 'malware',
    title: 'SolarMarker 백도어 - SEO 포이즈닝을 통한 유포',
    content: 'SolarMarker 백도어가 SEO 포이즈닝 기법으로 유포되고 있습니다. 인기 검색어로 가짜 웹사이트를 상위 노출시켜 사용자를 유인하고, PDF 뷰어나 문서 변환 도구로 위장한 악성 파일을 다운로드하게 합니다. .NET 기반으로 작성됐으며 강력한 난독화가 적용됐습니다.',
    tags: ['solarmarker', 'seo-poisoning', 'backdoor', 'dotnet', 'social-engineering'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 54,
    views_count: 10700,
    created_at: new Date(Date.now() - 39 * 3600000).toISOString(),
    profiles: {
      id: 'user50',
      username: 'malware_intel',
      display_name: 'Malware Intelligence',
      points: 11230,
      reputation: 3410
    }
  },
  {
    id: 'm21',
    user_id: 'user51',
    type: 'feed' as const,
    category: 'malware',
    title: 'Raspberry Robin 웜 - USB를 통한 기업 네트워크 침투',
    content: 'Raspberry Robin USB 웜이 기업 네트워크 침투의 초기 진입점으로 활발히 사용되고 있습니다. USB 드라이브를 통해 전파되며, 감염 후 다른 고급 멀웨어(Cobalt Strike, IcedID 등)의 드로퍼 역할을 합니다. 복잡한 난독화와 TOR 네트워크를 C2로 사용합니다.',
    tags: ['raspberry-robin', 'usb-worm', 'lateral-movement', 'dropper', 'tor'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 62,
    views_count: 12400,
    created_at: new Date(Date.now() - 41 * 3600000).toISOString(),
    profiles: {
      id: 'user51',
      username: 'worm_hunter',
      display_name: 'Worm Hunter',
      points: 10890,
      reputation: 3290
    }
  },
  {
    id: 'm22',
    user_id: 'user52',
    type: 'feed' as const,
    category: 'malware',
    title: 'Vidar Stealer 새로운 유포 채널 - 크랙 소프트웨어 번들링',
    content: 'Vidar Stealer가 크랙 소프트웨어와 번들링되어 유포되고 있습니다. Adobe, Microsoft Office 등 인기 소프트웨어의 크랙 버전에 포함되어 있으며, 토렌트 사이트를 통해 대규모로 확산되고 있습니다. 브라우저 데이터, 암호화폐 지갑, FTP 클라이언트 정보를 탈취합니다.',
    tags: ['vidar', 'stealer', 'piracy', 'torrent', 'bundling'],
    status: 'open',
    is_pinned: false,
    likes_count: 1345,
    replies_count: 51,
    views_count: 9800,
    created_at: new Date(Date.now() - 43 * 3600000).toISOString(),
    profiles: {
      id: 'user52',
      username: 'piracy_malware',
      display_name: 'Piracy Malware Tracker',
      points: 9560,
      reputation: 2890
    }
  },
  {
    id: 'm23',
    user_id: 'user53',
    type: 'feed' as const,
    category: 'malware',
    title: 'APT41 (Winnti) 새로운 루트킷 "Demodex" 분석',
    content: 'APT41 그룹이 사용하는 새로운 커널 모드 루트킷 Demodex를 분석했습니다. Windows 드라이버 서명 검증을 우회하여 설치되며, 프로세스 은닉, 네트워크 트래픽 숨김, 파일 시스템 필터링 등 전방위 은닉 기능을 제공합니다. 탐지가 극히 어렵습니다.',
    tags: ['apt41', 'winnti', 'rootkit', 'kernel-mode', 'china'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 89,
    views_count: 19700,
    created_at: new Date(Date.now() - 45 * 3600000).toISOString(),
    profiles: {
      id: 'user53',
      username: 'rootkit_analyst',
      display_name: 'Rootkit Analyst',
      points: 16230,
      reputation: 4980
    }
  },
  {
    id: 'm24',
    user_id: 'user54',
    type: 'feed' as const,
    category: 'malware',
    title: 'BPFDoor 백도어 - eBPF 기반 리눅스 은닉 기법',
    content: 'eBPF를 악용한 새로운 리눅스 백도어 BPFDoor를 분석했습니다. 커널 레벨에서 동작하며 netstat, lsof 등 모든 모니터링 도구를 우회합니다. 매직 패킷으로 활성화되는 포트 노킹 방식을 사용하며, 중국 APT 그룹과 연관된 것으로 추정됩니다.',
    tags: ['bpfdoor', 'ebpf', 'linux', 'backdoor', 'stealth'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 77,
    views_count: 16900,
    created_at: new Date(Date.now() - 47 * 3600000).toISOString(),
    profiles: {
      id: 'user54',
      username: 'linux_forensics',
      display_name: 'Linux Forensics Expert',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'm25',
    user_id: 'user55',
    type: 'feed' as const,
    category: 'malware',
    title: 'Raccoon Stealer v2 - 구독 기반 MaaS 모델 분석',
    content: 'Raccoon Stealer의 2세대 버전이 MaaS(Malware-as-a-Service) 모델로 운영되고 있습니다. 월 $200 구독료로 누구나 사용할 수 있으며, 웹 기반 관리 패널과 자동 빌더를 제공합니다. 탈취한 데이터는 자동으로 Telegram으로 전송되며, 50개 이상의 브라우저와 앱을 지원합니다.',
    tags: ['raccoon', 'stealer', 'maas', 'subscription', 'telegram'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 66,
    views_count: 13200,
    created_at: new Date(Date.now() - 49 * 3600000).toISOString(),
    profiles: {
      id: 'user55',
      username: 'maas_tracker',
      display_name: 'MaaS Tracker',
      points: 12450,
      reputation: 3780
    }
  }
];